import * as React from 'react'

import { InputField, InputFieldProps } from './input-field'

export const TextField = <T extends object>({ ...inputProps }: InputFieldProps<T>): JSX.Element => {
    return <InputField<T> type="text" {...inputProps} />
}
